import ListItemMaterial, { ListItemProps } from '@mui/material/ListItem'
import { lazy, ReactNode, Suspense } from 'react'
import { connectField } from 'uniforms'

import { Card } from '@mui/material'
import ListDelField from './ListDelField'

// Lazy load AutoField to break circular dependency
const AutoField = lazy(() => import('./AutoField'))

export type ListItemFieldProps = {
  children?: ReactNode
  dense?: ListItemProps['dense']
  disableGutters?: ListItemProps['disableGutters']
  divider?: ListItemProps['divider']
  removeIcon?: ReactNode
  removeItemCta?: string
  value?: unknown
}

function ListItem({
  children = (
    <Suspense fallback={<div>Loading...</div>}>
      <AutoField label={null} name="" />
    </Suspense>
  ),
  dense = true,
  disableGutters,
  divider,
  removeIcon,
  removeItemCta,
}: ListItemFieldProps) {
  return (
    <ListItemMaterial
      sx={{ pl: 0, pr: 0 }}
      dense={dense}
      disableGutters={disableGutters}
      divider={divider}
    >
      <Card sx={{ px: 2, py: 1 }}>{children}</Card>

      <ListDelField name="" icon={removeIcon} cta={removeItemCta} />
    </ListItemMaterial>
  )
}

export default connectField<ListItemFieldProps>(ListItem, {
  initialValue: false,
})
